<script setup lang="ts">
import {useI18n} from 'vue-i18n'
import IconComponent from '@toolify/client/src/modules/ui/components/IconComponent.vue'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {SizeVariantType} from '@toolify/client/src/modules/ui/enum/SizeVariantType'

// "+N hidden" pill: always the first child of .msg-stack, so it stays on top when the stack scrolls
interface Props {
  count: number
  severities: string[]
}

defineProps<Props>()

interface Emits {
  (e: 'showAll'): void
  (e: 'closeAll'): void
}

const emit = defineEmits<Emits>()

const {t} = useI18n()
</script>

<template>
  <div
    class="msg-overflow"
    role="group"
    :aria-label="t('notifications.messages.hiddenGroupLabel')"
    :hidden="count === 0"
    :data-overflow-severities="severities.join(' ')"
    data-overlay-ignore
  >
    <span class="msg-overflow__count">+{{count}}</span>
    <span class="msg-overflow__label">{{t('notifications.messages.hiddenCount', {count}, count)}}</span>
    <button
      type="button"
      class="msg-overflow__btn"
      data-action="show-all"
      :aria-label="t('notifications.messages.showHiddenAriaLabel')"
      @click="emit('showAll')"
    >
      {{t('notifications.messages.showHidden')}}
    </button>
    <button
      type="button"
      class="msg-overflow__btn"
      data-action="close-all"
      :aria-label="t('notifications.messages.closeAll')"
      @click="emit('closeAll')"
    >
      <IconComponent :name="IconNameType.Xmark" :size="SizeVariantType.XSmall" :color="null"/>
    </button>
  </div>
</template>
